import TimelineMap from "./TimelineMap.vue";

export default [
  { path: '/', component: TimelineMap },
  { path: '/:id', component: TimelineMap },
]